import { ThemeProvider } from 'styled-components';
import ErrorBoundary from '@/ErrorBoundary';
import MainLayout from '@/MainLayout';
import HeaderV2 from '@/Search/components/Header';
import StickySearchProvider from '@/Search/components/StickySearchProvider';
import FeatureBranch from '@/Search/FeatureBranch';
import theme from '~/theme';

export default function Search({ initialSeoProps }) {
  return (
    <ThemeProvider theme={theme}>
      <FeatureBranch />
      <HeaderV2 />
      <ErrorBoundary>
        <StickySearchProvider>
          <MainLayout initialSeoProps={initialSeoProps} />
        </StickySearchProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
